import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=d0c8ca46&scoped=true&"
import script from "./Codes.vue?vue&type=script&lang=js&"
export * from "./Codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c8ca46",
  null
  
)

export default component.exports